import React, { Component } from 'react';
import { Tabs, Button } from 'antd';
import { hashHistory } from 'react-router';

import Events from "../../services/events";

import PageHeader from "../../components/Modules/PageHeader";
import FilterPanel from "../../components/Modules/FilterPanel";
import CreateChannel from "../../components/CreateChannel";
import CreateContributor from "../../components/CreateContributor";

import './AdminConfiguration.less';

const TabPane = Tabs.TabPane;

export default class AdminConfiguration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: props.params.key.length > 1 ? '3' : props.params.key
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { key } = this.props.params;

    if (key.length === 1 && prevState.tab !== key) {
      this.handleTabsChange(key);
    }
  }

  filterBy(field, value) {
    Events.setFilter(field, value);
    this.setState({refresh: Math.random()})
  }

  handleTabsChange = (key) => {
    this.setState({ tab: key });
  }

  render() {
    const { channels, user, params, data } = this.props;
    const { userClaims, uid } = user;
    const { key } = params;
    let editChannel = channels && channels.find(channel => channel.id === key);
    let isAdmin = userClaims && userClaims.userType === 'Admin';

    const defaultChannel = {
      title: '',
      description: '',
      thumbnail: '',
      order: '',
    };

    let redirect = false;

    if (!uid) {
      redirect = true;
    }

    if (this.state.tab === "3") {
      let ownerId = editChannel && editChannel.ownerId;
      let isOwnChannel = ownerId && ownerId.find(userId => userId === userClaims.user_id);

      if (!isOwnChannel && !isAdmin) { redirect = true }
    } else {
      if (!isAdmin) { redirect = true }
    }

    if (redirect) {
      hashHistory.push(`/Channels`);
    }

    return (
      <React.Fragment>
        <PageHeader
          className="header"
          title="Admin Configuration"
          extra={
            <div className="search-form">
              <FilterPanel
                filter={this.filterBy}
                title="Channel search"
                type="channel"
                deviceType
              />
            </div>
          }
          extraMobile={
            <Button type="primary" shape="circle" icon="search" />
          }
          mobileTitleSearch="Channel search"
          mobileTypeSearch="channel"
        />
        <Tabs
          defaultActiveKey={this.state.tab}
          activeKey={this.state.tab}
          onChange={(key) => this.handleTabsChange(key)}
          className="create-panels" >
          <TabPane tab="Create Channel" disabled={!isAdmin} key="1">
            <div className="tab-content">
              <div className="container">
                <CreateChannel
                  channel={defaultChannel}
                  isNewElement={true}
                  isAdmin={isAdmin}
                  user={user}
                  isNotEdit={true}
                />
              </div>
            </div>
          </TabPane>
          <TabPane tab="Create Contributor" disabled={!isAdmin} key="2">
            <div className="tab-content">
              <div className="container">
                <CreateContributor
                  isAdmin={isAdmin}
                  data={data}
                />
              </div>
            </div>
          </TabPane>

          {
            (editChannel) && (
              <TabPane tab="Edit Channel" key="3">
                <div className="tab-content">
                  <div className="container">
                    <CreateChannel
                      channel={editChannel}
                      isNewElement={false}
                      isAdmin={isAdmin}
                      user={user}
                      isNotEdit={false}
                    />
                  </div>
                </div>
              </TabPane>
            )
          }
        </Tabs>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/AdminConfiguration/index.js